module.exports = __webpack_public_path__ + "img/table-bg-mob.5052f38.webp";